import { createContext, useContext } from 'react'
import { useClient } from '../../hooks/useClient'

const ApiRestClientContext = createContext()

const ApiRestClientProvider = ({ children }) => {
	const client = useClient()
	return <ApiRestClientContext.Provider value={client}>{children}</ApiRestClientContext.Provider>
}

export default ApiRestClientProvider
export const useApiRestClient = () => useContext(ApiRestClientContext)
